export type { DescriptionBoxProps } from './DescriptionBox'
export { DescriptionState } from './DescriptionBox'
export { DescriptionBox } from './DescriptionBox'
